



const darkMagic = {
    label: 'Dark Magic',
    background: '#091F2C',
    title: '#A286B8',
    typeBoxText: '#91E4D1',
}

const bentoTheme = {
    label: "Bento",
    background: "#2D394D",
    title: "#FF7A90",
    typeBoxText: "#4A768D",
    stats: "#FF7A90"
}


const futureFunkTheme = {
    label: "Future Funk",
    background: "#2E1A47",
    title: "#fff",
    typeBoxText: "#C18FFF",
    stats: "#fff"
}

const aetherTheme = {
    label: "Aether",
    background: "#101820",
    title: "#EEDAEA",
    typeBoxText: "#CF6BDD",
    stats: "#EEDAEA"
}
const skyTheme = {
    label: "Sky",
    background: "#87CEEB",
    title: "#FFFFFF",
    typeBoxText: "#4682B4",
    stats: "#FFFFFF"
};
const vintageTheme = {
    label: "Vintage",
    background: "#9B5A5A",
    title: "#F2DDB6",
    typeBoxText: "#FFFFFF",
    stats: "#F2DDB6"
};
const crimsonTheme = {
    label: "Crimson",
    background: "#990000",
    title: "#FFFFFF",
    typeBoxText: "#FF6347",
    stats: "#FFFFFF"
};
const earthyTheme = {
    label: "Earthy",
    background: "#694D33",
    title: "#D2B48C",
    typeBoxText: "#FFFFFF",
    stats: "#D2B48C"
};
const royalTheme = {
    label: "Royal",
    background: "#322F5D",
    title: "#FFD700",
    typeBoxText: "#FFFFFF",
    stats: "#FFD700"
};
const roseTheme = {
    label: "Rose",
    background: "#FFB6C1",
    title: "#800000",
    typeBoxText: "#FFFFFF",
    stats: "#800000"
};
const forestTheme = {
    label: "Forest",
    background: "#295939",
    title: "#E6E6FA",
    typeBoxText: "#8FBC8F",
    stats: "#E6E6FA"
};
const sunshineTheme = {
    label: "Sunshine",
    background: "#FFD700",
    title: "#FFFFFF",
    typeBoxText: "#FF6347",
    stats: "#FF6347"
};
const midnightTheme = {
    label: "Midnight",
    background: "#14172B",
    title: "#FFFFFF",
    typeBoxText: "#B7C5E6",
    stats: "#FFFFFF"
};
const oceanicTheme = {
    label: "Oceanic",
    background: "#28334C",
    title: "#70C0B1",
    typeBoxText: "#FFFFFF",
    stats: "#70C0B1"
};
const auroraTheme = {
    label: "Aurora",
    background: "#142850",
    title: "#FF6B6B",
    typeBoxText: "#F9F9F9",
    stats: "#FF6B6B"
};
const goldenSandsTheme = {
    label: "Golden Sands",
    background: "#FAD02C",
    title: "#4E3629",
    typeBoxText: "#FFFFFF",
    stats: "#4E3629"
};
const electricBlueTheme = {
    label: "Electric Blue",
    background: "#000080",
    title: "#00FFFF",
    typeBoxText: "#FFFFFF",
    stats: "#00FFFF"
};
const enchantedForestTheme = {
    label: "Enchanted Forest",
    background: "#355C7D",
    title: "#F8B195",
    typeBoxText: "#FFFFFF",
    stats: "#F8B195"
};
const rainbowDelightTheme = {
    label: "Rainbow Delight",
    background: "linear-gradient(to right, #FF5F6D, #FFC371, #FFEF96, #62D8D1, #8B5F84)",
    title: "#FFFFFF",
    typeBoxText: "#333333",
    stats: "#FFFFFF"
};
const neonGlowTheme = {
    label: "Neon Glow",
    background: "#000000",
    title: "#FF00FF",
    typeBoxText: "#00FF00",
    stats: "#00FFFF"
};
const tropicalParadiseTheme = {
    label: "Tropical Paradise",
    background: "#00FFFF",
    title: "#FF1493",
    typeBoxText: "#FFFF00",
    stats: "#FF1493"
};
const vibrantHuesTheme = {
    label: "Vibrant Hues",
    background: "#FF00FF",
    title: "#00FF00",
    typeBoxText: "#FFFF00",
    stats: "#00FFFF"
};
const pastelDreamsTheme = {
    label: "Pastel Dreams",
    background: "#F5F5DC",
    title: "#FF69B4",
    typeBoxText: "#87CEEB",
    stats: "#FF69B4"
};
const cosmicBurstTheme = {
    label: "Cosmic Burst",
    background: "radial-gradient(circle, #FF00FF, #0000FF, #00FFFF)",
    title: "#FFFFFF",
    typeBoxText: "#FFFF00",
    stats: "#FFFFFF"
};


const superUserTheme = {
    label: 'Super User',
    background: '#262A33',
    title: '#43FFAF',
    typeBoxText: '#526777'
}

export const themeOptions = [
    { value: superUserTheme, label: 'Super User' },
    { value: darkMagic, label: 'Dark Magic' },
    { value: bentoTheme, label: "Bento" },
    { value: futureFunkTheme, label: "Future Funk" },
    { value: aetherTheme, label: "Aether" },
    { value: pastelDreamsTheme, label: 'Pastel Dreams' },
    { value: cosmicBurstTheme, label: 'Cosmic Burst' },
    { value: vibrantHuesTheme, label: 'Vibrant Hues' },
    { value: tropicalParadiseTheme, label: 'Tropical Paradise' },
    { value: neonGlowTheme, label: 'Neon Glow' },
    { value: rainbowDelightTheme, label: 'Rainbow Delight' },
    { value: enchantedForestTheme, label: 'Enchanted Forest' },
    { value: electricBlueTheme, label: 'Electric Blue' },
    { value: goldenSandsTheme, label: 'Golden Sands' },
    { value: auroraTheme, label: 'Aurora' },
    { value: oceanicTheme, label: 'Oceanic' },
    { value: midnightTheme, label: 'Midnight' },
    { value: sunshineTheme, label: 'Sunshine' },
    { value: royalTheme, label: 'Royal' },
    { value: roseTheme, label: 'Rose' },
    { value: forestTheme, label: 'Forest' },
    { value: earthyTheme, label: 'Earthy' },
    { value: crimsonTheme, label: 'Crimson' },
    { value: skyTheme, label: 'Sky' },
    { value: vintageTheme, label: 'Vintage' }

];

